import * as React from 'react'
import { lightTheme } from '@/customTheme'

/**
 * Generic "position" glyph — four focus corner-brackets with a centered dot.
 * Not specific to any one surface (used by the Batch add-menu rail, but not
 * tied to it); matches Figma node 12082-1012205.
 */
function PositionIcon({ size = 24, color = lightTheme.colors.blackGray }: { size?: number; color?: string }) {
  const s = { fill: 'none', stroke: color, strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      {/* top-left */}
      <path d="M3 7V4.5C3 3.67 3.67 3 4.5 3H7" {...s} />
      {/* top-right */}
      <path d="M17 3H19.5C20.33 3 21 3.67 21 4.5V7" {...s} />
      {/* bottom-right */}
      <path d="M21 17V19.5C21 20.33 20.33 21 19.5 21H17" {...s} />
      {/* bottom-left */}
      <path d="M7 21H4.5C3.67 21 3 20.33 3 19.5V17" {...s} />
      {/* center dot */}
      <circle cx="12" cy="12" r="2" fill={color} />
    </svg>
  )
}

export default PositionIcon
